import React, { useCallback } from "react";
import { Menu, Button, Modal, Popover } from "antd";
import { useIntl } from "react-intl";

import { warn } from "../../../../modules/messages";

const { Item } = Menu;
const { confirm } = Modal;

const ExportMenu = ({ intl, onPdfClick, onExcelClick }) => (
  <Menu className="dropdown-menu">
    <Item key={1} onClick={onPdfClick}>
      {intl.formatMessage({
        id: "export.pdf",
        defaultMessage: "ve formátu pdf",
      })}
    </Item>
    <Item key={2} onClick={onExcelClick}>
      {intl.formatMessage({
        id: "export.xlsx",
        defaultMessage: "ve formátu xlsx",
      })}
    </Item>
  </Menu>
);

function ExportButton({
  text,
  entity,
  address,
  entities,
  disabled,
  workEntities,
  entitiesToPdf,
  entitiesToExcel,
}) {
  const intl = useIntl();
  const exportEntities = useCallback(
    (exportFunction) => {
      if (workEntities && workEntities.length > 0) {
        exportFunction(workEntities, intl, address);
      } else if (entities && entities.length > 0) {
        confirm({
          title: intl.formatMessage({
            id: "messages.warning",
            defaultMessage: "Upozornění",
          }),
          content: intl.formatMessage(
            {
              id: "export.noEntitiesAll",
              defaultMessage:
                "Nemáte vybrané žádné {entity}, přejete si exportovat všechny načtené {entity}?",
            },
            { entity }
          ),
          okText: intl.formatMessage({
            id: "messages.yes",
            defaultMessage: "Ano",
          }),
          cancelText: intl.formatMessage({
            id: "messages.no",
            defaultMessage: "Ne",
          }),
          onOk: () => exportFunction(entities, intl, address),
        });
      } else {
        warn(
          intl.formatMessage(
            {
              id: "export.noEntities",
              defaultMessage:
                "Nemáte vybrané žádné {entity}, zkuste změnit atributy filtru.",
            },
            { entity }
          )
        );
      }
    },
    [intl, address, entity, workEntities, entities]
  );

  const onExcelClick = useCallback(() => {
    exportEntities(entitiesToExcel);
  }, [exportEntities, entitiesToExcel]);

  const onPdfClick = useCallback(() => {
    exportEntities(entitiesToPdf);
  }, [exportEntities, entitiesToPdf]);

  return (
    <Popover
      trigger="click"
      placement="bottomRight"
      content={
        <ExportMenu
          intl={intl}
          onPdfClick={onPdfClick}
          onExcelClick={onExcelClick}
        />
      }
    >
      <Button icon="export" type="primary" disabled={disabled}>
        {text}
      </Button>
    </Popover>
  );
}

export default ExportButton;
